<template>
	<section class="section">
		<div class="container-fluid">
			<card ref="card" title="" icon="">
				<form-field label="企業名" sub="" :has-wrap="false">
					<div class="field">
						<b-select v-model="customerId" @input="onCustomerSelectChange">
							<option
								v-for="customer in customers"
								:value="customer.id"
								:key="customer.id">
								{{ customer.name }}
							</option>
						</b-select>
					</div>
				</form-field>

				<form-field label="グループ" sub="" :has-wrap="false">
					<div class="field">
						<b-select v-model="groupId">
							<option
								v-for="group in groups"
								:value="group.id"
								:key="group.id">
								{{ group.name }}
							</option>
						</b-select>
					</div>
				</form-field>

				<form-field label="スタッフID" sub="必須" :has-wrap="false">
					<div class="field">
						<p class="control is-expanded">
							<input class="input" :class="{'is-danger': hasError('code')}" type="text" v-model="code" placeholder="半角英数小文字16文字以内">
						</p>
						<p slot="help" class="help is-danger" v-show="hasError('code')">{{ errors.code }}</p>
					</div>
				</form-field>

				<form-field label="名前" sub="必須" :has-wrap="false">
					<div class="field">
						<p class="control is-expanded">
						<input class="input" :class="{'is-danger': hasError('name')}" type="text" v-model="name">
						</p>
						<p slot="help" class="help is-danger" v-show="hasError('name')">{{ errors.name }}</p>
					</div>
				</form-field>

				<form-field label="フリガナ" sub="必須" :has-wrap="false">
					<div class="field">
						<p class="control is-expanded">
							<input class="input" :class="{'is-danger': hasError('nameKana')}" type="text" v-model="nameKana">
						</p>
						<p slot="help" class="help is-danger" v-show="hasError('nameKana')">{{ errors.nameKana }}</p>
					</div>
				</form-field>

				<form-field label="電話番号" sub="必須" :has-wrap="false">
					<div class="field">
						<p class="control is-expanded">
							<input class="input" :class="{'is-danger': hasError('tel')}" type="text" placeholder="ハイフンなし" v-model="tel">
						</p>
						<p slot="help" class="help is-danger" v-show="hasError('tel')">{{ errors.tel }}</p>
					</div>
				</form-field>

				<form-field label="メールアドレス" sub="必須" :has-wrap="false">
					<div class="field">
						<p class="control is-expanded">
							<input class="input" :class="{'is-danger': hasError('email')}" type="text" v-model="email">
						</p>
						<p slot="help" class="help is-danger" v-show="hasError('email')">{{ errors.email }}</p>
					</div>
				</form-field>

				<form-field label="ステータス" sub=" " :has-wrap="false">
					<radio-picker :options="staffStatuses" v-model="staffStatusId"></radio-picker>
				</form-field>

				<form-field label="権限" sub=" " :has-wrap="false">
					<div class="field-body">
						<checkbox-picker :options="permissions" v-model="staffPermissions" type=""></checkbox-picker>
					</div>
				</form-field>

				<form-field :has-wrap="false">
					<div class="edit-buttons">
						<b-button type="is-light" @click="onBackButtonClick">戻る</b-button>
						<b-button type="is-success" :loading="isLoading" @click="onRegisterButtonClick">登録</b-button>
						<b-button v-if="id" type="is-warning" :loading="isPwdResetLoading" @click="onPwdResetButtonClick">パスワードリセット</b-button>
					</div>
				</form-field>
			</card>
		</div>
	</section>
</template>

<script>
import Card from '@/components/Card'
import FormField from '@/components/FormField'
import RadioPicker from "@/components/RadioPicker";
import CheckboxPicker from "@/components/CheckboxPicker";
export default {
	name: "staff-edit",
	components: {
		RadioPicker,
		Card,
		FormField,
		CheckboxPicker,
	},
	data() {
		return {
			customerId: '',
			customers: null,
			isLoading: false,
			isPwdResetLoading: false,
			staffStatusId: '',
			staffStatuses: null,
			staffPermissions: [],
			permissions: [],
			id: '',
			code: '',
			name: '',
			nameKana: '',
			tel: '',
			email: '',
			groups: [],
			groupId: '',
			errors: {
				code: '',
				name: '',
				nameKana: '',
				tel: '',
				email: '',
			}
		}
	},
	computed: {
	},
	mounted() {
		let subTitle = this.$route.params.staffId ? '更新' : '新規作成';
		this.$store.commit('basic', {
			key: 'titleBarTitleStack',
			value: ['スタッフ管理', subTitle]
		})
		this.getData();
	},
	methods: {
		hasError: function(key) {
			return this.errors[key] !== '';
		},
		onCustomerSelectChange: function() {
			this.groupId = '';
			this.getGroup();
		},
		getGroup: async function() {
			let loading = this.$loading.open();
			let ep = 'groups?customer_id=' + this.customerId;
			this.$utils.log(ep);

			try {
				let res = await this.$api.get(ep, null, true);
				this.$utils.log(res);
				this.groups = res.data.list;
				if (this.groupId === '') {
					this.groupId = this.groups[0].id;
				}
			} catch (error) {
				this.$utils.log(error);
				this.$utils.toastError(error.response.data.message);
			} finally {
				loading.close();
			}
		},
		getData: async function() {
			let loading = this.$loading.open();
			let params = this.$route.params.staffId ? '/' + this.$route.params.staffId : '';
			let ep = 'staffs/screen' + params;
			this.$utils.log(ep);

			try {
				let res = await this.$api.get(ep, null, true);
				this.$utils.log(res);
				this.staffStatuses = res.data.staff_statuses;
				this.id = res.data.id;
				this.code = res.data.code;
				this.name = res.data.name;
				this.nameKana = res.data.name_kana;
				this.tel = res.data.tel;
				this.email = res.data.email;
				this.staffStatusId = res.data.staff_status_id;
				this.permissions = res.data.permissions;
				this.staffPermissions = res.data.staff_permissions;
				this.customerId = res.data.customer_id;
				this.customers = res.data.customers;
				this.groupId = res.data.group_id;
				this.getGroup();
			} catch (error) {
				this.$utils.log(error);
				this.$utils.toastError(error.response.data.message);
			} finally {
				loading.close();
			}
		},
		onRegisterButtonClick: async function() {
			for (let key in this.errors) {
				this.errors[key] = '';
			}

			this.isLoading = true;
			let data = {
				"id": this.id,
				"code": this.code,
				"name": this.name,
				"name_kana": this.nameKana,
				"tel": this.tel,
				"email": this.email,
				"staff_status_id": this.staffStatusId,
				"staff_permissions": this.staffPermissions,
				"customer_id": this.customerId,
				"group_id": this.groupId,
			};
			this.$utils.log(data);

			let ep = 'staffs';
			this.$utils.log(ep);

			try {
				let res = await this.$api.post(ep, data, true);
				this.$utils.log(res);
				this.$router.push({ name: 'staff' });
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
				if (error.response.status === 400) {
					let details = error.response.data.details;
					for (let key in details) {
						this.errors[this.$utils.toCamelCase(key)] = details[key];
					}
				}
			} finally {
				this.isLoading = false;
			}
		},
		onBackButtonClick: function() {
			this.$router.go(-1);
		},
		onPwdResetButtonClick: async function() {
			if (!window.confirm('パスワードをリセットします。リセットしたパスワードはメールアドレス宛に送信されます。よろしいですか？')) {
				return false;
			}

			this.isPwdResetLoading = true;
			let data = {
				"id": this.id,
			};
			this.$utils.log(data);

			let ep = 'staffs/pwd-reset';
			this.$utils.log(ep);

			try {
				let res = await this.$api.post(ep, data, true);
				this.$utils.log(res);
				this.$utils.toastSuccess(res.data.message);
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			} finally {
				this.isPwdResetLoading = false;
			}
		},
	}
}
</script>

<style scoped>
</style>
